import React from 'react';
import { Spin } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';

export default function LocalLoader({ children, isLoading, size }) {
    return (
        <>
            {isLoading ? (
                <div className="local-loader__container">
                    <Spin
                        indicator={
                            <Loading3QuartersOutlined
                                style={{
                                    fontSize: size,
                                }}
                                spin
                            />
                        }
                    />
                </div>
            ) : (
                <>{children}</>
            )}
        </>
    );
}
